import { Component, OnInit } from "@angular/core";
import { ViewController } from "ionic-angular";

@Component({
  selector: "task-log-modal",
  templateUrl: "task-log.modal.html"
})
export class TaskLogModal implements OnInit {
  constructor(
    private viewCtrl: ViewController
  ) {}

  ngOnInit() {}

  dismiss($event) {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/modals/task-log.modal/task-log.modal.ts